// src/services/customerAuth.js

// Mock customer database - maps customer codes to their info
// In production, this would be replaced with a backend API
const CUSTOMERS = {
    'CUST001': {
        id: 'CUST001',
        name: '김철수',
        albumId: 'album_kim_chulsoo',
    },
    'CUST002': {
        id: 'CUST002',
        name: '이영희',
        albumId: 'album_lee_younghee',
    },
    'CUST003': {
        id: 'CUST003',
        name: '박민수',
        albumId: 'album_park_minsoo',
    },
    'CUST004': {
        id: 'CUST004',
        name: '스타트업 오피스',
        albumId: 'album_business_user',
    },
    // Add more customers as needed
};

export const validateCustomer = (customerCode) => {
    return new Promise((resolve, reject) => {
        // Simulate API delay
        setTimeout(() => {
            const customer = CUSTOMERS[customerCode.toUpperCase()];
            if (customer) {
                resolve(customer);
            } else {
                reject(new Error('고객 코드를 찾을 수 없습니다.'));
            }
        }, 500);
    });
};

export const getCustomerById = (customerId) => {
    return CUSTOMERS[customerId];
};
